import React from 'react'
import { Typography, useTheme } from '@mui/material'
import { Container, InputButton } from './styles'
import type { NumpadInputButtonProps } from './types'

const NumpadInputButton: React.FC<NumpadInputButtonProps> = ({
  buttonType = 'button',
  input,
  icon,
  onClick,
  testId,
  ariaLabel,
}) => {
  const { palette } = useTheme()
  const hasContent = Boolean(icon ?? input)
  const content = icon ?? (
    <Typography color={palette.text.primary} variant="h5">
      {input}
    </Typography>
  )

  return (
    <Container>
      <InputButton
        variant="text"
        color="inherit"
        aria-label={ariaLabel}
        onClick={onClick}
        data-testid={testId}
        type={buttonType}
        fullWidth
        disabled={!hasContent}
        className="icon-container"
      >
        {content}
      </InputButton>
    </Container>
  )
}

export default NumpadInputButton
